/** Conversas: o item da lista, os inputs de criação/edição e o quadro Kanban. */
import { z } from "zod";
import { conversationKind, conversationStatus, messageStatus } from "../enums.js";
import { cursorPage, uuid } from "./common.js";

/* ---------- Conversas ---------- */
export const conversation = z.object({
  id: uuid,
  channelId: uuid,
  channelName: z.string(),
  kind: conversationKind,
  status: conversationStatus,
  contactName: z.string(),
  contactAvatarUrl: z.string().nullable(),
  lastMessagePreview: z.string().nullable(),
  lastMessageAt: z.string().nullable(),
  /** Direcao da ultima mensagem; a lista usa para o prefixo "Você:". */
  lastMessageOutgoing: z.boolean().optional(),
  /** Nome de quem enviou a ultima mensagem (grupos); a lista usa como prefixo. */
  lastMessageSenderName: z.string().nullable().optional(),
  /** Ack da ultima mensagem, so quando enviada por nos; vira os tiques na lista. */
  lastMessageStatus: messageStatus.optional(),
  unreadCount: z.number().int().nonnegative(),
  pinnedAt: z.string().nullable(),
  labels: z.array(z.object({ id: uuid, name: z.string(), color: z.string() })),
  assignee: z.object({ id: uuid, name: z.string() }).nullable(),
  slaFirstResponseDueAt: z.string().nullable(),
});
export type Conversation = z.infer<typeof conversation>;

export const startConversationInput = z.object({
  channelId: uuid,
  /** E.164 (docs/04 §1): +DDI+numero, sem espacos ou pontuacao. */
  phone: z.string().regex(/^\+[1-9][0-9]{7,14}$/, "Telefone deve estar em E.164 (ex.: +5511999999999)"),
  name: z.string().min(1).max(120).optional(),
});
export type StartConversationInput = z.infer<typeof startConversationInput>;

export const renameContactInput = z.object({
  name: z.string().min(1).max(120),
});
export type RenameContactInput = z.infer<typeof renameContactInput>;

export const conversationListInput = cursorPage.extend({
  filtro: z.enum(["todas", "nao_lidas", "minhas", "fixadas", "sem_resposta"]).default("todas"),
  etiqueta: z.string().optional(),
  assignee: uuid.optional(),
  status: conversationStatus.optional(),
  q: z.string().optional(),
});
export type ConversationListInput = z.infer<typeof conversationListInput>;

/* ---------- Kanban (Tarefas) ---------- */
export const boardColumn = z.object({
  status: conversationStatus,
  cards: z.array(conversation),
  total: z.number().int().nonnegative(),
});
export const conversationBoard = z.object({ columns: z.array(boardColumn) });
export type ConversationBoard = z.infer<typeof conversationBoard>;
